import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { ConfigurationActionContext } from "./ConfigurationActionContext";

function useUpdate() {
  const { element, setBackendFormErrors } = useContext(ConfigurationActionContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    update("producers", element.id, element)
      .then((response: any) => {
        setBackendFormErrors({});
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
